/**
 * Module dependencies.
 */

import React from 'react';
import { GlobalPrevision } from './global-prevision';
import { LastLineProps } from 'app/components/organisms/crud/form-types';
import { OpenClose } from './open-close';
import { Report } from './report';
import { Payments } from './payments';

/**
 * Export `TableFooter` component.
 */

export function TableFooter({ data }: LastLineProps): JSX.Element {
  return (
    <div className={'pt-6 flex flex-row [grid-column:1/15] justify-between items-start'}>
      <div className={'flex flex-row justify-center items-start gap-10'}>
        <GlobalPrevision data={data} />

        <OpenClose data={data} />

        <Payments data={data} />

        <Report data={data} />
      </div>
    </div>
  );
}
